import React, { useEffect, useState, useRef } from "react";
import DBAnimation from "../components/DBAnimation";
import DBApplicationForm from "./DBApplicationForm";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { getCurrentDateTime } from "../utils/formatting";
import AccordionImage from "../components/AccordionImage";

// import { Helmet } from "react-helmet";

const TAX_cop_1 = () => {
  const navigate = useNavigate(); // ✅ useNavigate 추가
  const location = useLocation();

  useEffect(() => {
    // 네이버 광고 로그 스크립트 실행 함수
    function loadNaverAdsScript() {
      const script = document.createElement("script");
      script.src = "//wcs.naver.net/wcslog.js";
      script.type = "text/javascript";
      document.head.appendChild(script);

      const inlineScript = document.createElement("script");
      inlineScript.type = "text/javascript";
      inlineScript.innerHTML = `
              if (!wcs_add) var wcs_add = {};
              wcs_add["wa"] = "s_1f14cf3a248f";
              if (!_nasa) var _nasa = {};
              if (window.wcs) {
                  wcs.inflow("smilevent.co.kr");
                  wcs_do();
              }
          `;
      document.head.appendChild(inlineScript);
    }

    // 스크립트 로드
    loadNaverAdsScript();

    // 스크립트 정리
    return () => {
      document
        .querySelectorAll(
          'script[src="//wcs.naver.net/wcslog.js"], script[type="text/javascript"]'
        )
        .forEach((el) => document.head.removeChild(el));
    };
  }, [location.pathname]);

  const urlCodeSettingId = 10;
  const urlCode = "OQRSXN";

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    industry: "",
    region: "",
    revenue: "",
    privacyPolicy: true,
    thirdPartyAgreement: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ 유효성 검사 (Validation)
    if (formData.name.length < 2) {
      alert("이름은 최소 2글자 이상 입력해야 합니다.");
      return;
    }
    if (formData.phone.length < 10) {
      alert("전화번호는 최소 10자리 이상 입력해야 합니다.");
      return;
    }
    if (!formData.privacyPolicy) {
      alert("개인정보 취급방침에 동의해 주세요.");
      return;
    }
    if (!formData.thirdPartyAgreement) {
      alert("제3자 정보제공에 동의해 주세요.");
      return;
    }

    // ✅ industry, region, revenue를 합쳐서 selectedOption으로 변환
    const selectedOption = [
      formData.industry,
      formData.region,
      formData.revenue,
    ]
      .filter((item) => item) // 빈 값 제거
      .join(",");

    const date = getCurrentDateTime();

    const requestData = {
      urlCodeSettingId,
      urlCode,
      name: formData.name,
      phoneNumber: formData.phone,
      selectedOption, // industry, region, revenue 합친 값
      date,
    };

    try {
      const response = await axios.post(
        "https://blog.smilevent.co.kr/api/randing/customer",
        requestData
      );
      console.log("서버 응답:", response.data);

      // ✅ 성공적으로 데이터가 전송된 경우
      alert("신청이 완료되었습니다."); // 성공 메시지
      navigate("/taxend"); // ✅ /thanks 페이지로 이동
    } catch (error) {
      console.error("데이터 전송 실패:", error);
    }
  };

  const imageSources = [
    {
      src: `${process.env.REACT_APP_CDN_BASE}/images/tax/1.jpg`,
      alt: "Main Image",
    },
  ];

  const footerPath = `${process.env.REACT_APP_CDN_BASE}/images/tax/footer.jpg`;
  const quickImagePath = `${process.env.REACT_APP_CDN_BASE}/images/tax/quick.png`;

  const dbApplicationFormRef = useRef(null);

  const scrollToDBApplicationForm = () => {
    dbApplicationFormRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <div className="blog-container">
        <div className="image-section">
          {imageSources.map((image, index) => (
            <img
              key={index}
              src={image.src}
              alt={image.alt}
              className="blog-image"
            />
          ))}
        </div>

        <div className="additional-content">
          <DBAnimation />
          <div ref={dbApplicationFormRef}>
            <DBApplicationForm
              formData={formData}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
            />
          </div>
        </div>

        <AccordionImage imageSrc={footerPath} />
        <img
          src={quickImagePath}
          alt="Quick Image"
          className="quick-image"
          onClick={scrollToDBApplicationForm}
        />

        <style jsx>{`
          .blog-container {
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .image-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
          }
          .blog-image {
            width: 100%;
            max-width: 600px;
          }
          .additional-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            max-width: 600px;
          }

          .footer-image {
            width: 100%;
            max-width: 600px;
            display: block;
          }
          .quick-image {
            position: fixed;
            bottom: 30px;
            right: 30px;
            width: 70px;
            height: 70px;
            cursor: pointer;
          }
        `}</style>
      </div>
    </>
  );
};

export default TAX_cop_1;
